import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import logo from 'utils/icon/logo.png';

/**
 *
 * @param {*} param0
 * @returns {사이드바 없는 페이지 (로그인)}
 */

interface IProps {
  children: JSX.Element[] | JSX.Element;
}
const FullLayout: React.FC<IProps> = ({ children }) => {
  return (
    <Container>
      <LogoBox>
        <img src={logo} alt='Pier Corporation' />
      </LogoBox>
      <InputBox>{children}</InputBox>
    </Container>
  );
};

export default FullLayout;

const Container = styled.div`
  /* height: 100%; */
  min-height: 100vh;
  background-color: ${theme.colors.gray_1};
  position: relative;
`;
const LogoBox = styled.div`
  position: absolute;
  width: 20rem;
  left: 50%;
  transform: translate(-55%);
  top: 7rem;
  img {
    width: inherit;
    object-fit: cover;
  }
`;
const InputBox = styled.div`
  position: absolute;
  top: 18rem;
  left: 50%;
  transform: translate(-50%);
  width: 30rem;
  height: 15rem;
  background-color: #fff;
`;
